import React from "react";

/**
 * TS Doc Info
 * @component BilderAdmin
 */
export function BilderAdmin(): React.ReactElement {
  return (<>BilderAdmin</>)
}
